import React from 'react';
import { Box, Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import brandConfig from './brandConfig';

const hostname = window.location.hostname.replace(/^www\./, '');
const { hero } = brandConfig[hostname] || brandConfig.default;

const HeroSection = () => (
  <Box
    sx={{
      position: 'relative',
      height: '80vh',
      backgroundImage: `url(${hero})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'rgba(49,23,75,0.5)',
        padding: 4,
        borderRadius: 2,
        color: '#fff'
      }}
    >
      <Typography variant="h3" align="center">
        <Trans i18nKey="hero.text">
          ¡Muy pronto, <strong>Mevuelo</strong> estará aquí!
        </Trans>
      </Typography>
    </Box>
  </Box>
);

export default HeroSection;
